module.exports = __webpack_public_path__ + "static/media/group_26.ffdf42e5.png";